import { Box, Button, HStack, VStack, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import { MdSettingsPhone } from 'react-icons/md'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../context/AuthContext'
import { isProd } from '../../utils/common'
import ReservationCreate from '../VideoGroupReservationCreate'
import ActiveRooms from './ActiveRooms'
import MyReservedRooms from './MyReservedRooms'
import { VideoButton } from './VideoGroupButtons'

const TABS = [
  {
    label: 'さあ・くる会議室一覧',
    path: '/video/group',
    component: <ActiveRooms />,
  },
  {
    label: '予約一覧',
    path: '/video/group/my-reserved-rooms',
    component: <MyReservedRooms />,
  },
  {
    label: '予約作成',
    path: '/video/group/reservation/create',
    component: <ReservationCreate />,
  },
]

const VideoGroupIndex: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { me } = useAuthContext()
  const isMobile = useBreakpointValue({ base: true, md: false })
  
  // 現在のパスに最もマッチするタブを選択
  const activeTab = TABS.find((tab) => location.pathname === tab.path) || TABS[0]
  const callSettingClick = () => {
    navigate('/mypage/video')
  }

  // TODO #615 暫定本番解放
  // 本番解放時にはこの条件を削除してください
  const shouldShowTabs = !isProd() || me?.isOffice === true
  // タブが表示されない場合は最初のタブのコンポーネントのみ表示
  if (!shouldShowTabs) {
    return (
      <Box maxW="900px" mx="auto" py={6}>
        <Box>
          <ActiveRooms />
        </Box>
      </Box>
    )
  }

  return (
    <Box maxW="900px" mx="auto" py={6}>
      {isMobile ? (
        <VStack spacing={4} mb={6} align="stretch" px="16px">
          <HStack spacing={2} justify="flex-start" flexWrap="wrap">
            {TABS.map(tab => (
              <Button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                colorScheme='primary'
                backgroundColor={activeTab.path === tab.path ? 'theme.primary' : 'grand.graySuperLight'}
                color={activeTab.path === tab.path ? 'text.white' : 'text.sub'}
                fontWeight="bold"
                fontSize="sm"
                px={3}
                py={2}
                minH="40px"
                _hover={{ backgroundColor: 'theme.primary', color: 'text.white' }}
                variant="ghost"
                whiteSpace="normal"
                height="auto"
                lineHeight="1.2"
              >
                {tab.label}
              </Button>
            ))}
          </HStack>
          <Box display="flex" justifyContent="flex-end">
            <VideoButton icon={MdSettingsPhone} onClick={callSettingClick}>
              通話の詳細設定
            </VideoButton>
          </Box>
        </VStack>
      ) : (
        <HStack spacing={3} mb={6} justify="center">
          {TABS.map(tab => (
            <Button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              colorScheme='primary'
              backgroundColor={activeTab.path === tab.path ? 'theme.primary' : 'grand.graySuperLight'}
              color={activeTab.path === tab.path ? 'text.white' : 'text.sub'}
              fontWeight="bold"
              fontSize="lg"
              px={8}
              py={4}
              _hover={{ backgroundColor: 'theme.primary', color: 'text.white' }}
              variant="ghost"
            >
              {tab.label}
            </Button>
          ))}
          <VideoButton icon={MdSettingsPhone} onClick={callSettingClick}>
            通話の詳細設定
          </VideoButton>
        </HStack>
      )}
      <Box>
        {activeTab.component}
      </Box>
    </Box>
  )
}

export default VideoGroupIndex
